import { watch } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import log from "@/utils/log";

export const useAuth = () => {
  const MAX_WAIT_TIME_IN_MILLISECONDS = 10000;

  const {
    getAccessTokenSilently,
    logout: logoutAuth0,
    isLoading,
    isAuthenticated,
  } = useAuth0();

  const waitForAuthReady = (): Promise<boolean> => {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        resolve(false);
      }, MAX_WAIT_TIME_IN_MILLISECONDS);

      let stop = (): void => {};
      stop = watch(
        isLoading,
        (newIsLoading) => {
          if (!newIsLoading) {
            clearTimeout(timeout);
            stop();
            resolve(isAuthenticated.value);
          }
        },
        { immediate: true },
      );
    });
  };

  const fetchToken = async (): Promise<string> => {
    const authenticated = await waitForAuthReady();
    if (!authenticated) {
      log("waitForAuthReady() has returned false");
      return "";
    }
    try {
      return await getAccessTokenSilently();
    } catch (error) {
      log("getAccessTokenSilently() has failed");
      log(error instanceof Error ? error.message : "Unknown error");
      return "";
    }
  };

  const logout = async (): Promise<void> => {
    await logoutAuth0({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return { fetchToken, logout };
};
